import React, { useState } from 'react';

import axios from 'axios';

import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Stack from '@mui/material/Stack';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import AddIcon from '@mui/icons-material/Add';

export default function DistributionsCollapse({ open, invoice, accounts }) {
    const [invoiceDistributions, setInvoiceDistributions] = useState(invoice.distributions);
    const [invoicePrintsDistributions, setInvoicePrintsDistributions] = useState(invoice.printsdistributions);

    const prints_types = {'C': 'couleur', 'B&W': 'noir et blanc'}

    return (
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                        <Typography variant="h6" gutterBottom component="div">
                            Détail
                        </Typography>
                        <Table size="small" aria-label="items">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Intitulé</TableCell>
                                    <TableCell align="right">Montant (€)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {invoiceDistributions && invoiceDistributions.length > 0 ? (
                                    invoiceDistributions.map((invoiceRow) => (
                                        <TableRow key={invoiceRow.id}>
                                            <TableCell component="th" scope="row">
                                                {invoiceRow.label}
                                            </TableCell>
                                            <TableCell align="right">{invoiceRow.amount.toLocaleString('fr-FR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={4} align="center">
                                            Aucune prestation facturée
                                        </TableCell>
                                    </TableRow>
                                )}
                                {invoicePrintsDistributions && invoicePrintsDistributions.length > 0 ?(
                                    invoicePrintsDistributions.map((invoicePrintsRow) =>(
                                        <TableRow key={invoicePrintsRow.id}>
                                            <TableCell component="th" scope='row'>
                                                Copies {prints_types[invoicePrintsRow.type]}
                                            </TableCell>
                                            <TableCell align='right'>{invoicePrintsRow.price.toLocaleString('fr-FR', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                    <TableCell colSpan={4} align="center">
                                    </TableCell>
                                </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Box>
                </Collapse>
            </TableCell>
        </TableRow>
    );
};